//Reset data
export const RESET = "MOTIF_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "MOTIF_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "MOTIF_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "MOTIF_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "MOTIF_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "MOTIF_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "MOTIF_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "MOTIF_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "MOTIF_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "MOTIF_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "MOTIF_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "MOTIF_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "MOTIF_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "MOTIF_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "MOTIF_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "MOTIF_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "MOTIF_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "MOTIF_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "MOTIF_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "MOTIF_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "MOTIF_DEL_SET_IS_UPDATE"